import React, { Component } from 'react';
import './GlobalMenuModal.css';
class GlobalMenuModal extends Component {

    _eraseAll()
    {
        this.props.leafs.forEach((leaf)=>{
            if(leaf.id>1){this.props.delete(leaf.id)}})
    }


    _getLocalStorageKeys()
    {
        let out=[];
        for (var i = 0; i < localStorage.length; i++) {
            out.push(localStorage.key(i).replace(/^persist:/,""));
        }
        return out;
    }

    _getURLs()
    {
        let out=this._getLocalStorageKeys().map((key)=>{
            return {name: decodeURI(key)  , url: (window.location.href.replace(/\?.*$/,"") +"?key=" + key)}
        })
        return out;
    }

    _getLinks()
    {
        let out=this._getURLs().map((item)=><div><a href={item.url}>{item.name}</a></div>)
        return out;
    }

    _getLinkToNewItem()
    {
        let out=<div><a href={(window.location.href.replace(/\?.*$/,"") +"?key=" + this.state.newname)}>{this.state.newname}</a></div>
        return out;

    }

    onChangeHander(e)
    {
        this.setState({newname: e.target.value})
    }

    _getOpenButton()
    {
        return <div>
            <input type="file" className="GlobalMenuModal-save" onChange={(e)=>{this.props.open(e);this.props.closeModal()}}></input>
        </div>
    }


    _getDownloadLink()
    {
        if (this.props.downloadLink==="")
        {
            return ""
        }
        else
        {
            return <a id="download" href={this.props.downloadLink} download="treemindmap.tmm">Download</a>
        }
    }


    _getNewlyCreateForm()
    {
        return <div><input type="text" className="GlobalMenuModal-inputnew" onChange={(e)=>this.onChangeHander(e)}></input>
            {this._getLinkToNewItem()}
        </div>
    }

    _getDOM()
    {
        return(
            <div className="GlobalMenuModal" style={this.props.style}>
                <div className='GlobalMenuModal-title'>Open</div>
                <div  className='GlobalMenuModal-Item'>
                    {this._getOpenButton()}
                </div>
                <div className='GlobalMenuModal-title'>Save </div>
                <div  className='GlobalMenuModal-Item'>
                    {this._getDownloadLink()}
                </div>
                <div className='GlobalMenuModal-title'>About</div>
                <div className='GlobalMenuModal-Item'>
                    <div><a href="https://3yaa3yaa.netlify.app">About developer</a></div>
                </div>
                <div className='GlobalMenuModal-Item'>
                    <div><a href="https://twitter.com/3yaa3yaa_en">Contact me via Twitter</a> </div>
                </div>
                <div className='GlobalMenuModal-Item'>
                    <div><a href="https://3yaa3yaa.netlify.app/document/privacy-policy-of-tmm-webapp">Privacy Policy</a> </div>
                </div>
            </div>
        )

    }



    render() {
        return this._getDOM()
        //return this.state.modal
    }
}


export default GlobalMenuModal;
